
import SVG from 'svgjs';

export const DIAGRAM_LOCATION = '/api/configuration/vehicle-diagrams';

export const svgOpenTag = '<svg preserveAspectRatio="xMinYMin" class="marker" xmlns="http://www.w3.org/2000/svg" id="svg71" viewBox="0 0 70 99">';
export const svgCloseTag = '</svg>';

export const MARKER_GROUP_ID = 'MARKER_GROUP';

export const TEMP_MARKER_COLOUR = 'orange';
export const NEW_DAMAGE_COLOUR = 'red';
export const PRE_EXIST_DAMAGE_COLOUR = 'orange';

export const MARKER_SVG = {
  TEMPORARY: `<g id="g69" transform="scale(0.20)translate(-35, -99)"><path fill="${TEMP_MARKER_COLOUR}" id="path12" vector-effect="non-scaling-stroke" d="M68.98 36C69.7 18.1 53.52 1.6 35.23 1.6 16.93 1.6.75 13.67 1.47 36 2.04 53.7 35.1 97.46 35.1 97.46S68.3 53.73 69 36z"/></g>`,
  NEW_DAMAGE: `<g id="g69" transform="scale(0.15)translate(-35, -99)"><path fill="${NEW_DAMAGE_COLOUR}" id="path12" vector-effect="non-scaling-stroke" d="M68.98 36C69.7 18.1 53.52 1.6 35.23 1.6 16.93 1.6.75 13.67 1.47 36 2.04 53.7 35.1 97.46 35.1 97.46S68.3 53.73 69 36z"/></g>`,
  PRE_EXIST_DAMAGE: `<g id="g69" fill="${PRE_EXIST_DAMAGE_COLOUR}" transform="scale(0.15)translate(-35, -99)"><path id="path12" vector-effect="non-scaling-stroke" d="M68.98 36C69.7 18.1 53.52 1.6 35.23 1.6 16.93 1.6.75 13.67 1.47 36 2.04 53.7 35.1 97.46 35.1 97.46S68.3 53.73 69 36z"/><path id="path815" fill="white" stroke-width="1" stroke="black" d="M45.82 49.9l-11-6.74-11.32 6.17 3.02-12.54-9.37-8.9 12.86-1 5.56-11.64 4.93 11.92 12.8 1.66-9.83 8.37z"/></g>`,
};

export const SELECTED_AREA_CLASS = 'vehicle-area-highlight';

export const diagramPaddingPx = 200; // Magic number!

export function createUnionRect(a, b) {
  if (!a && !b) return null;
  if (!b) return a;
  if (!a) return b;

  const x = Math.min(a.x, b.x);
  const y = Math.min(a.y, b.y);
  const width = Math.max((a.x + a.width), (b.x, b.width)) - x; // Calculates the right-edge x co-ord, then calculates width.
  const height = Math.max((a.y + a.height), (b.y + b.height)) - y; // Calculates the bottom-edge y co-ord, then calculates height.

  return new SVG.Rect()
    .x(x)
    .y(y)
    .width(width)
    .height(height);
}

export function bboxEquals(a, b) {
  return a.x !== b.x && a.y !== b.y && a.width !== b.width && a.height !== b.height;
}

export function calculateElementBboxAfterTransform(svg, el) {
  var bb = el.getBBox();

  if (!el.transform || !el.transform.baseVal || el.transform.baseVal.numberOfItems < 1)
  {
      return bb;
  }
  // The matrix definition of the transform (consolidate converts all the rotates and translates into one matrix form)
  var m   = el.transform.baseVal.consolidate().matrix;
  // Create an array of all four points for the current bounding box
  var pts = [
    svg.createSVGPoint(), svg.createSVGPoint(),
    svg.createSVGPoint(), svg.createSVGPoint()
  ];
  pts[0].x=bb.x;          pts[0].y=bb.y;
  pts[1].x=bb.x+bb.width; pts[1].y=bb.y;
  pts[2].x=bb.x+bb.width; pts[2].y=bb.y+bb.height;
  pts[3].x=bb.x;          pts[3].y=bb.y+bb.height;

  // Transform each and calculate the new min/max points from that.
  var xMin=Infinity,xMax=-Infinity,yMin=Infinity,yMax=-Infinity;
  pts.forEach(function(pt){
    pt = pt.matrixTransform(m);
    xMin = Math.min(xMin,pt.x);
    xMax = Math.max(xMax,pt.x);
    yMin = Math.min(yMin,pt.y);
    yMax = Math.max(yMax,pt.y);
  });

  // Create new Bounding box with the new values (Cannot modify the original one because I.E. thinks it is read only)
  var newBb = svg.createSVGRect();
  // Update the bounding box with the new values
  newBb.x = xMin; newBb.width  = xMax-xMin;
  newBb.y = yMin; newBb.height = yMax-yMin;

  return newBb;
}